import { action, observable } from 'mobx';

export class ConfirmDialogVM {
  @observable isOpen: boolean = false;
  @observable message: string = '';
  @observable title: string = '';

  private resolveDialogResult?: (value: boolean) => void;

  @action.bound showDialog(message: string, title: string): Promise<boolean> {
    const currentPromise: Promise<boolean> = new Promise((resolve, reject) => {
      this.resolveDialogResult = resolve;
    });

    this.message = message;
    this.title = title;
    this.isOpen = true;
    return currentPromise;
  }

  @action.bound refocus(elementToFocus) {
    if (elementToFocus && document.body.contains(elementToFocus)) {
      (elementToFocus as HTMLElement).focus();
    }
  }

  @action.bound accept(): void {
    if (this.resolveDialogResult) {
      //close dialog
      this.isOpen = false;

      //resolve the promise
      this.resolveDialogResult(true);

      //discard callback handle
      this.resolveDialogResult = undefined;
    }
  }

  @action.bound cancel(): void {
    if (this.resolveDialogResult) {
      //close dialog
      this.isOpen = false;

      //resolve the promise
      this.resolveDialogResult(false);

      //discard callback handle
      this.resolveDialogResult = undefined;
    }
  }
}
